import { App as CapacitorApp } from "@capacitor/app";
import { Capacitor, SystemBars, SystemBarsStyle } from "@capacitor/core";
import { Haptics, NotificationType } from "@capacitor/haptics";
import { Network } from "@capacitor/network";
import { SplashScreen } from "@capacitor/splash-screen";

export const isNativeApp = Capacitor.isNativePlatform();

export async function initializeNativeRuntime() {
  if (!isNativeApp) return;
  document.documentElement.dataset.nativeApp = "true";

  await Promise.allSettled([
    SystemBars.setStyle({ style: SystemBarsStyle.Light }),
    SplashScreen.hide(),
  ]);

  await CapacitorApp.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack) window.history.back();
    else void CapacitorApp.minimizeApp();
  });

  const status = await Network.getStatus();
  publishNetworkStatus(status.connected);
  await Network.addListener("networkStatusChange", ({ connected }) => {
    publishNetworkStatus(connected);
  });
}

function publishNetworkStatus(connected: boolean) {
  window.dispatchEvent(
    new CustomEvent<boolean>("restlab:network", { detail: connected }),
  );
}

export async function notifyNativeSuccess() {
  if (!isNativeApp) return;
  await Haptics.notification({ type: NotificationType.Success }).catch(
    () => undefined,
  );
}

export async function notifyNativeError() {
  if (!isNativeApp) return;
  await Haptics.notification({ type: NotificationType.Error }).catch(
    () => undefined,
  );
}
